import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import IllustrationUsageHistory from '../../../domain/entities/IllustrationUsageHistory';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexIllustrationUsageHistoriesSuccess: {
      const result =
        action.payload as PaginatedResult<IllustrationUsageHistory>;
      return mergeResponse(state, result);
    }
    case Types.UpdateIllustrationUsageHistorySuccess: {
      const illustrationUsageHistory =
        action.payload as IllustrationUsageHistory;
      const newState = {} as QueryState;
      Object.keys(state).forEach(stateKey => {
        const response = {...state[stateKey]};
        const filteredIds = response.pageToIds[1].filter(
          id => id !== illustrationUsageHistory.id,
        );
        if (
          stateKey.includes(`"storyId":${illustrationUsageHistory.storyId}`)
        ) {
          response.pageToIds[1] = [illustrationUsageHistory.id, ...filteredIds];
        }
        newState[stateKey] = response;
      });
      return newState;
    }
    default:
      return state;
  }
}
